import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ColumnTypeEnum } from '@y42/json-schema';
import { tap } from 'rxjs';
import { OperationInputFormService } from '../../operation-input-form.service';

@UntilDestroy()
@Component({
  selector: 'y42-operation-input-delete[columnType][index]',
  templateUrl: './operation-input-delete.component.html',
  styleUrls: ['./operation-input-delete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationInputDeleteComponent {
  constructor(private readonly formService: OperationInputFormService, private readonly cdRef: ChangeDetectorRef) {
    this.formService.reset$
      .pipe(
        tap(() => this.cdRef.markForCheck()),
        untilDestroyed(this),
      )
      .subscribe();
  }

  @Input() columnType!: ColumnTypeEnum;
  @Input() index!: number;

  readonly operationsFormArray = this.formService.operationsFormArray;

  removeOperation() {
    this.formService.removeOperation(this.index);
    this.cdRef.markForCheck();
  }
}
